<template>
  <!-- <sidebar-item :link="{ name: 'Status', path: '/settings/leadStatus' }" v-if="checkRoleType(['corporate', 'admin', 'manager']) && checkAccess(['stg_lead_status'])"></sidebar-item> -->
          <!-- <sidebar-item :link="{ name: 'Customer Status', path: '/settings/customerStatus' }" v-if="checkRoleType(['corporate', 'admin', 'manager']) && checkAccess(['stg_customer_status'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Channel & Platform', path: '/settings/channelSetting' }" v-if="(checkRoleType(['corporate', 'admin', 'director'])) && checkAccess(['stg_channel_platform'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Mortgage Status', path: '/settings/mortgageStatus' }" v-if="(checkAppCode('sas') && checkRoleType(['corporate', 'admin', 'director'])) && checkAccess(['stg_mortgage_status'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Personal Loan Status', path: '/settings/personalLoanStatus' }" v-if="(checkAppCode('sas') && checkRoleType(['corporate', 'admin', 'director'])) && checkAccess(['stg_personal_loan_status'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Insurance Status', path: '/settings/insuranceStatus' }" v-if="(checkAppCode('sas') && checkRoleType(['corporate', 'admin', 'director']))  && checkAccess(['stg_insurance_status'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Other Loan Status', path: '/settings/otherLoanStatus' }" v-if="(checkAppCode('sas') && checkRoleType(['corporate', 'admin', 'director']))  && checkAccess(['stg_other_loan_status'])"></sidebar-item>
          <sidebar-item :link="{ name: 'Advisory Status', path: '/settings/advisoryStatus' }" v-if="(checkAppCode('sas') && checkRoleType(['corporate', 'admin', 'director']))"></sidebar-item> -->
         
	<div>
    <base-header class="pb-0">
				<b-row align-v="center" class="py-1">
						<b-col cols="12">
								<h2 class="listing-title d-inline-block mb-0">Status Setting</h2>
						</b-col>
						<b-col cols="12" class="text-right ">
							<el-tabs v-model="current_tab">
								<el-tab-pane label="Lead Status" name="leadStatus">
									<router-link slot="label" :to="'/settings/leadStatus'" class="text-dark">Lead Status</router-link>
								</el-tab-pane>
								<el-tab-pane label="Customer Status" name="customerStatus">
									<router-link slot="label" :to="'/settings/customerStatus'" class="text-dark">Customer Status</router-link>
								</el-tab-pane>
								<el-tab-pane label="Mortgage Status" name="mortgageStatus">
									<router-link slot="label" :to="'/settings/mortgageStatus'" class="text-dark">Mortgage Status</router-link>
								</el-tab-pane>
								<el-tab-pane label="Personal Loan Status" name="personalLoanStatus">
									<router-link slot="label" :to="'/settings/personalLoanStatus'" class="text-dark">Personal Loan Status</router-link>
								</el-tab-pane>
								<el-tab-pane label="Insurance Status" name="insuranceStatus">
									<router-link slot="label" :to="'/settings/insuranceStatus'" class="text-dark">Insurance Status</router-link>
								</el-tab-pane>
								<el-tab-pane label="Other Loan Status" name="otherLoanStatus">
									<router-link slot="label" :to="'/settings/otherLoanStatus'" class="text-dark">Other Loan Status</router-link>
								</el-tab-pane>
								<el-tab-pane label="Advisory Status" name="advisoryStatus">
									<router-link slot="label" :to="'/settings/advisoryStatus'" class="text-dark">Advisory Status</router-link>
								</el-tab-pane>
							</el-tabs>
						</b-col>
				</b-row>
		</base-header>
	</div>	
</template>

<script>
import { Tabs, TabPane } from 'element-ui'

export default {
		props: ['tab_name'],
    components: {
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    data() {
        return {
            modals:{
                create_new: false,
                update_status: false,
            },
            backButton: false,
						current_tab: this.tab_name
        };
    },
    methods: {
			handleTabClick(obj, e) {
				
      }
    }
}
</script>